import React from 'react'

function Home() {
  return (
    <div className='mainDiv'>APP running.</div>
  )
}

export default Home